import Http from '@/api/http.js'

export default {
  index(){
    return Http.get(`/employee_roles`);
  },
  
}